import React from "react";
import { Box } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const TotalCostIcon = ({ amount }) => {
    const safeAmount = Number.isFinite(amount) && amount > 0 ? amount : 0;
    const formattedAmount = safeAmount.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return (
        <Box
            sx={{
                width: 64,
                height: 44,
                borderRadius: 1.5,
                overflow: "hidden",
                border: 2,
                borderColor: "success.main",
                textAlign: "center",
                bgcolor: "background.paper",
                boxShadow: 0,
                display: "flex",
                flexDirection: "column",
            }}
            aria-hidden
        >
            <Box
                sx={{
                    bgcolor: "success.main",
                    color: "common.white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "0 0 40%",
                    gap: 0.25,
                }}
            >
                <AttachMoneyIcon sx={{ fontSize: "1rem" }} />
            </Box>
            <Box
                sx={{
                    color: "text.primary",
                    fontWeight: 700,
                    fontSize: "0.85rem",
                    lineHeight: 1,
                    flex: "1 1 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 0.5,
                }}
            >
                {formattedAmount}
            </Box>
        </Box>
    );
};

export default TotalCostIcon;
